export default function AdTypesFactory() {
  const vm = {};

  vm.ALL_TYPES = [
    'display_rich_media',
    'native_outstream',
    'instream_video',
    'native_display',
    'isi',
    'banner',
    'scroller',
    'thumbnail_carousel',
    'full_ad_carousel'
  ];

  return vm;
}
